"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialFilters = void 0;
const getInitialFilters = () => {
    const storedFilters = localStorage.getItem('filters');
    if (storedFilters)
        return JSON.parse(storedFilters);
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setHours(0, 0, 0, 0);
    return {
        globalFilterValue: '',
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        clubId: null,
    };
};
exports.getInitialFilters = getInitialFilters;
